import React from 'react';
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Typography,
  useTheme
} from '@mui/material';

const EnhancedTable = ({ 
  headers, 
  rows, 
  title,
  caption,
  stickyHeader = false,
  maxHeight = null,
  sx = {}
}) => {
  const theme = useTheme();
  
  return (
    <Paper 
      elevation={theme.palette.mode === 'dark' ? 3 : 2} 
      sx={{ 
        mb: 3, 
        overflow: 'hidden', 
        borderRadius: 2,
        border: '1px solid',
        borderColor: theme.palette.mode === 'dark' ? 'rgba(255,255,255,0.1)' : theme.palette.divider,
        ...sx 
      }}
    >
      {title && (
        <Typography 
          variant="subtitle1" 
          sx={{ 
            p: 2.5, 
            fontWeight: 'bold',
            bgcolor: theme.palette.mode === 'dark' 
              ? theme.palette.primary.dark 
              : theme.palette.primary.light, 
            color: theme.palette.mode === 'dark' 
              ? theme.palette.primary.contrastText 
              : theme.palette.primary.dark
          }}
        >
          {title}
        </Typography>
      )}
      <TableContainer sx={{ maxHeight: maxHeight || 'none' }}>
        <Table stickyHeader={stickyHeader} sx={{ minWidth: 650 }}>
          <TableHead>
            <TableRow>
              {headers.map((header, index) => (
                <TableCell 
                  key={index}
                  sx={{ 
                    fontWeight: 'bold', 
                    bgcolor: theme.palette.mode === 'dark' 
                      ? 'rgba(255,255,255,0.08)' 
                      : theme.palette.grey[100],
                    color: theme.palette.mode === 'dark' 
                      ? theme.palette.primary.light 
                      : theme.palette.primary.dark,
                    borderBottom: '2px solid',
                    borderBottomColor: theme.palette.primary.main,
                    fontSize: '0.875rem',
                    whiteSpace: 'nowrap'
                  }}
                >
                  {header}
                </TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {rows.map((row, rowIndex) => (
              <TableRow 
                key={rowIndex}
                sx={{ 
                  '&:nth-of-type(odd)': { 
                    bgcolor: theme.palette.mode === 'dark' 
                      ? 'rgba(255,255,255,0.03)' 
                      : theme.palette.action.hover 
                  },
                  '&:hover': { 
                    bgcolor: theme.palette.mode === 'dark' 
                      ? 'rgba(255,255,255,0.08)' 
                      : theme.palette.action.selected 
                  },
                  transition: 'background-color 0.2s'
                }}
              >
                {row.map((cell, cellIndex) => (
                  <TableCell 
                    key={cellIndex}
                    sx={{ 
                      borderBottom: '1px solid',
                      borderBottomColor: theme.palette.mode === 'dark' 
                        ? 'rgba(255,255,255,0.1)' 
                        : theme.palette.divider,
                      color: theme.palette.text.primary
                    }}
                  >
                    {cell}
                  </TableCell>
                ))}
              </TableRow>
            ))}
          </TableBody>
        </Table>
        {caption && (
          <Typography 
            variant="caption" 
            sx={{ 
              display: 'block', 
              p: 1.5, 
              textAlign: 'center',
              bgcolor: theme.palette.mode === 'dark' 
                ? 'rgba(255,255,255,0.05)' 
                : theme.palette.grey[50],
              color: theme.palette.text.secondary
            }}
          >
            {caption}
          </Typography>
        )}
      </TableContainer>
    </Paper>
  );
};

export default EnhancedTable;